<template>
    <div class="mt-4">
        <p class="election_date">
            Volby do Poslanecké sněmovny se uskuteční 3. a 4. října 2025
        </p>
        <div>
            <div class="slogan-bar w-100">
                <div class="line-red">
                </div>
                <div class="line-blue">
                </div>
                <span class="slogan-text">
                    Spojeni. Pro vás!
                </span>
                <div class="line-blue">
                </div>
                <div class="line-red">
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8">
                    <img alt="Spojená loga SPD, Svobodní, Trikolóra, PRO" src="/loga_spojeni.png" class="w-100 px-2">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>

<style lang="scss">
.election_date {
    font-size: 1.4rem;
    color: #d40000;
    margin-bottom: 1.5rem;
    font-weight: 700;
}

.slogan-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
    flex-wrap: nowrap;
    .line-red {
        height: 4px;
        background-color: red;
        flex: 2;
        max-width: 200px;
    }
    .line-blue {
        height: 4px;
        background-color: #0072ce;
        flex: 1;
        max-width: 100px;
    }
    .slogan-text {
        font-family: 'Protest Riot', cursive;
        font-family: 'Protest Riot', sans-serif;
        font-size: 2rem;
        color: #004080;
        white-space: nowrap;
        padding: 0 1rem;
    }
}
</style>